import { request } from '@/utils/request';
import { MedicalUnit } from '@/api/medicalUnits/medicalUnits.types';

export async function getDataAboutPharmacy() {
  return request<MedicalUnit>('/units/2');
}